import BrandLoading from '@/utils/loading/BrandLoading';

export default BrandLoading;
